import { useContext } from 'react';
import { PyodideContext } from '@playground/SQL/context';

export function usePyodide() {
  const pyodide = useContext(PyodideContext);

  if (pyodide === null) {
    throw new Error(`[pyodide]: "usePyodide" must be wrapped by a "PyodideProvider"`);
  }

  return {
    pyodide,
  };
}
